/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.13.0
 */

import { Fragment } from 'react';

import { SkeletonParagraph } from '../../../../../components/common';
import { ESkeletonKind } from '../../../../../components/common/Skeleton/skeletonTypes';
import { SubscriberIdSkeletonStyled } from '../../styled/PageSubscriberIdStyled';
import { SubscriberInfoDataInfoStyled } from './styled/SubscriberInfoDataInfoStyled';

const paragraphStyle = { width: 300 };
const btnStyle = { width: 200, marginTop: 16 };

export const SubscriberIdPersonalDataSkeleton = () => (
    <Fragment>
        <SubscriberIdPersonalDataStatusSkeleton />
        <SubscriberIdPersonalDataInfoSkeleton />
    </Fragment>
);

export const SubscriberIdPersonalDataStatusSkeleton = () => (
    <SubscriberIdSkeletonStyled>
        <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
        <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
        <SkeletonParagraph kind={ESkeletonKind.BUTTON_ROUND} style={btnStyle}/>
    </SubscriberIdSkeletonStyled>
);

export const SubscriberIdPersonalDataInfoSkeleton = () => (
    <SubscriberIdSkeletonStyled>
        <SubscriberInfoDataInfoStyled>

            <div className="personal-data__block">
                <SkeletonParagraph
                    className="subscriber-id__title"
                    kind={ESkeletonKind.PARAGRAPH_SMALL}
                    style={{ marginBottom: 16 }}
                />
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
            </div>
            <div className="personal-data__block">
                <SkeletonParagraph className="subscriber-id__title" kind={ESkeletonKind.PARAGRAPH_SMALL}
                                   style={{ marginBottom: 16 }}/>
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
                <div className="personal-data__group">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                </div>
            </div>
        </SubscriberInfoDataInfoStyled>
    </SubscriberIdSkeletonStyled>

);
